import { Progress } from "@chakra-ui/react";

export const LinearProgress = () => {
  return (
    <Progress.Root value={null} width="100%" aria-label="Loading" role="status">
      <Progress.Track>
        <Progress.Range />
      </Progress.Track>
    </Progress.Root>
  );
};
